@if (applicationStateService.userData.isTeacher) {
    <div class="worksheet-container">
        <h3 class="title"><img [src]="'sidebar/sidebar-icon-calcuflow.png' | asset">Arbeitsblätter und Schularbeiten
        </h3>
        <button (click)="openWorksheetEditor()" [disabled]="!teacherToolActive"
                class="title btn btn-round btn-semibold btn-blue">Arbeitsblatt-Editor öffnen
        </button>
        @if (!teacherToolActive) {
            <p><em>Für diese Seite gibt es leider keine passenden Inhalte im Arbeitsblatt-Editor.</em></p>
        }
    </div>

    <hr>

    @if (worksheets?.length > 0) {
        <div>
            <h3>Aus deinen Aufgaben erstellte Arbeitsblätter</h3>
            <ul class="worksheet-list">
                @for (worksheet of worksheets; track worksheet) {
                    <li>
                        <sidebar-worksheet-item [worksheet]="worksheet"></sidebar-worksheet-item>
                    </li>
                }
            </ul>
            <p><em>Es werden die zuletzt erstellten Arbeitsblätter angezeigt</em></p>
        </div>
    }
}